import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-candidate-card-view',
    templateUrl: './candidate-card-view.component.html',
    styleUrls: ['./candidate-card-view.component.scss'],
    standalone: false
})
export class CandidateCardViewComponent implements OnInit {
  @Input() candidateDetails: any;
  @Input() i: any;
  currentLocation: any;

  constructor() { }

  ngOnInit(): void {
    this.currentLocation = this.candidateDetails.location_name ? this.candidateDetails.location_name : this.candidateDetails.location_names && this.candidateDetails.location_names.length ? this.candidateDetails.location_names[0] : 
    this.candidateDetails.location_region && this.candidateDetails.location_locality && this.candidateDetails.location_country ? 
    `${this.candidateDetails.location_region}  ${this.candidateDetails.location_locality}  ${this.candidateDetails.location_country}` : 
    this.candidateDetails.location_region && this.candidateDetails.location_country ? `${this.candidateDetails.location_region}  ${this.candidateDetails.location_country}` :
    this.candidateDetails.location_locality && this.candidateDetails.location_country ? `${this.candidateDetails.location_locality}  ${this.candidateDetails.location_country}` :
    this.candidateDetails.location_region ? `${this.candidateDetails.location_region}` :
    this.candidateDetails.location_locality ? `${this.candidateDetails.location_locality}` : this.candidateDetails.location_country ? `${this.candidateDetails.location_country}` : '';
  }

  openUrl(link, type) {
    if (link.startsWith("www.linkedin") || link.startsWith("www.facebook") || link.startsWith("www.twitter") || link.startsWith("www.github"))
      link = "https://" + link;
    else if (type == 'linkedin' && !(link.includes("https://www.linkedin") || link.includes("https://linkedin") || link.includes("https://in.linkedin") || link.includes("http://linkedin") || link.includes("http://www.linkedin")))
      link = "https://www." + link;
    else if (type == 'facebook' && !(link.includes("https://www.facebook") || link.includes("https://facebook") || link.includes("https://in.facebook") || link.includes("http://facebook") || link.includes("http://www.facebook")))
      link = "https://www." + link;
    else if (type == 'twitter' && !(link.includes("https://www.twitter") || link.includes("https://twitter") || link.includes("https://in.twitter") || link.includes("http://twitter") || link.includes("http://www.twitter")))
      link = "https://www." + link;
    else if (type == 'github' && !(link.includes("https://www.github") || link.includes("https://github") || link.includes("https://in.github") || link.includes("http://github") || link.includes("http://www.github")))
      link = "https://www." + link;
    window.open(link, "_blank")
  }


  isBoolean(value: any) {
    if (typeof value == 'boolean' || value == 'true') {
      return true;
    }
    return false;
  }

  transform(value: string | string[]): string {
    if (!value) {
      return '';
    }

    if (Array.isArray(value)) {
      value = value[0] || '';
    }

    const regex = /(<.*?>)?([^<>]+)/g;
    const transformedValue = value.replace(regex, (match, htmlTag, text) => {
      if (text) {
        const transformedText = text.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
        const result = htmlTag ? `${htmlTag}${transformedText}` : transformedText;
        // remove htmltag
        if (result.includes('<')) {
          return result.replace(/<.*?>/g, '');
        }

        return result;
      }
      return match;
    });

    return transformedValue;
  }

}
